export const SCOPES = 'openid profile email';
export const MARKETPLACE_APP_ID = 'avera';

export const LITELLM_DEFAULT_BASE_URL = 'https://llm.sensifai.com';
export const LITELLM_DEFAULT_MODEL = 'sensifai-fast';

export const LITELLM_MODEL_ALIASES = {
  FAST: 'sensifai-fast',
  REASONING: 'sensifai-reasoning',
  VISION: 'sensifai-vision',
} as const;

export function normalizeModelAlias(rawModel?: string): string {
  if (!rawModel || rawModel.trim() === '') {
    return LITELLM_MODEL_ALIASES.FAST;
  }
  const m = rawModel.toLowerCase().trim();
  if (m === 'sensifai-fast' || m === 'sensifai-reasoning' || m === 'sensifai-vision') {
    return m;
  }
  if (m.startsWith('sensifai-')) {
    return m;
  }
  // Check reasoning models (claude sonnet/opus, deepseek r1, o1, o3, o3-mini, reasoning)
  if (m.includes('claude') || m.includes('sonnet') || m.includes('opus') || m.includes('reasoning') || m.includes('o1') || m.includes('o3') || m.includes('r1')) {
    return LITELLM_MODEL_ALIASES.REASONING;
  }
  // Check vision and image models
  if (m.includes('vision') || m.includes('image') || m.includes('gpt-4o')) {
    return LITELLM_MODEL_ALIASES.VISION;
  }
  // Map fast / flash / mini / turbo models
  if (m.includes('gemini') || m.includes('flash') || m.includes('mini') || m.includes('turbo')) {
    return LITELLM_MODEL_ALIASES.FAST;
  }
  return LITELLM_MODEL_ALIASES.FAST;
}

